<template>
    <div class="customerDefinedAlarmConfigurationSearch">
        <Row :gutter="8" style="margin-bottom: 8px;">
            <!-- 选择公司 -->
            <Col span="4" v-if="company==1">
                <Select v-model="companyId" filterable :placeholder="$t('ApprovalTask.selectByCompany')" :transfer="true">
                    <Option value=" ">{{ $t('ApprovalTask.selectAll') }}</Option>
                    <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <Col span="4">
                <Select v-model="accountTypeSearchKey" filterable :placeholder="$t('configuration_management.customized_alarm_config.selectCloudPlatform')" :transfer="true" @on-change="onAccountTypeChange">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in accountTypeList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <!-- 监控模块筛选 -->
            <Col span="4">
                <Select v-model="monitorModuleSearchKey" filterable :placeholder="$t('configuration_management.common.monitorModule')" :transfer="true" @on-change="onMonitorModuleChange">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                </Select>
            </Col>
            <!-- 监控指标筛选 -->
            <Col span="4">
                <Tooltip :disabled="monitorIndexEnabled" :content="$t('configuration_management.customized_alarm_config.selectCloudPlatformAndMonitorModule')" placement="top" :transfer="true" style="width: 100%;">
                    <Select v-model="monitorIndexSearchKey" filterable :placeholder="$t('alarms.common.monitorIndex')" :transfer="true" :disabled="!monitorIndexEnabled">
                        <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in monitorIndexList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Tooltip>
            </Col>
        </Row>
        <Row :gutter="8">
            <!-- 优先级筛选 -->
            <Col span="4">
                <Select v-model="prioritySearchKey" filterable :placeholder="$t('configuration_management.common.priority')" :transfer="true">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option :value="item.value" v-for="item in priorityOptions" :key="item.value">{{item.label}}</Option>
                </Select>
            </Col>
            <!-- 状态筛选 -->
            <Col span="4">
                <Select v-model="stateSearchKey" filterable :placeholder="$t('AlertConfigManagement.CostomizedAlarm.status')" :transfer="true">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option value="true">{{ $t('permission_configuration_management.account.enable') }}</Option>
                    <Option value="false">{{ $t('permission_configuration_management.account.disable') }}</Option>
                </Select>
            </Col>
            <!-- AI 监控报警状态筛选 -->
            <Col span="4" v-if="company == 1">
                <Select v-model="aiMonitorAlertStatusSearchKey" filterable :placeholder="$t('configuration_management.customized_alarm_config.AIMonitorsTheAlarmStatus')" :transfer="true">
                    <Option value=" ">{{ $t('configuration_management.common.all') }}</Option>
                    <Option value="true">{{ $t('permission_configuration_management.account.enable') }}</Option>
                    <Option value="false">{{ $t('permission_configuration_management.account.disable') }}</Option>
                </Select>
            </Col>
            <Col span="2">
                <Button type="primary" @click="doSearch">{{ $t('configuration_management.customized_alarm_config.query') }}</Button>
            </Col>
            <Col :span="company == 1 ? 10 : 14" style="text-align: right;">
                <Button type="primary" @click="to" v-hasPermission="['configurationManagement:alertRuleLists']">{{ this.$t('configuration_management.customized_alarm_config.checkTheListOfAlarmRules') }}</Button>
                <Button v-if="company == 1" type="primary" style="margin-left: 8px" @click="showAIDialog">{{ $t('configuration_management.customized_alarm_config.setUniversalSOP') }}</Button>
            </Col>
        </Row>
      <Modal
        v-model="openAIDialog"
        width="1000"
        :title="$t('configuration_management.customized_alarm_config.setUpAUniversalAIAlarmHandlingProcess')"
        footer-hide
      >
        <div class="sop-split-layout">
          <!-- 左侧：优先级列表 -->
          <div class="sop-priority-list">
            <div
              v-for="item in aiList"
              :key="item.priority"
              class="sop-priority-item"
              :class="{ active: selectedSopItem && selectedSopItem.priority === item.priority }"
              @click="selectSopItem(item)"
            >
              <div style="font-weight: 600;">{{ item.priorityShowName }}</div>
              <div style="font-size: 12px; color: #808695; margin-top: 4px;">{{ (item.sopSteps && item.sopSteps.length) || 0 }} {{ $t('configuration_management.customized_alarm_config.steps') }}</div>
              <div style="margin-top: 8px;">
                <span style="font-size: 12px; margin-right: 8px;">{{ $t('configuration_management.customized_alarm_config.emailNotification') }}</span>
                <i-switch v-model="item.enableEmail" size="small" @on-change="changeStatus(item)" />
              </div>
            </div>
          </div>
          <!-- 右侧：步骤详情 -->
          <div class="sop-detail-panel">
            <div v-if="selectedSopItem">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                <span style="font-weight: 600; font-size: 14px;">{{ selectedSopItem.priorityShowName }} {{ $t('configuration_management.customized_alarm_config.universalAIAlarmProcess') }}</span>
                <Button type="primary" size="small" @click="showSopItem(selectedSopItem)">{{ $t('configuration_management.customized_alarm_config.editAIAlarmProcessBtn') }}</Button>
              </div>
              <div v-if="selectedSopItem.sopSteps && selectedSopItem.sopSteps.length > 0" class="sop-timeline-wrap">
                <div class="sop-step-list">
                  <div v-for="(val, index) in selectedSopItem.sopSteps" :key="val.stepId" class="sop-step-row" style="cursor: default;">
                    <div class="sop-step-dot">{{ index + 1 }}</div>
                    <div style="flex: 1; line-height: 24px; color: #515a6e;">{{ val.stepInfo }}</div>
                  </div>
                </div>
              </div>
              <div v-else style="color: #808695; padding: 20px 0; text-align: center;">{{ $t('configuration_management.customized_alarm_config.noStepsTip') }}</div>
            </div>
            <div v-else style="color: #808695; padding: 40px 0; text-align: center;">{{ $t('configuration_management.customized_alarm_config.selectPriorityTip') }}</div>
          </div>
        </div>
      </Modal>
      <Modal
        v-model="showEditAI"
        width="800"
        :title="$t('configuration_management.customized_alarm_config.editGeneralAIAlarmProcess')"
        footer-hide
      >
        <div>
          <Card>
            <div style="font-weight: 700;">{{ aiItemData.priorityShowName }}</div>
            <div style="margin-top: 10px;">
              <div>{{ $t('configuration_management.customized_alarm_config.pleaseEnterTheProcessContent') }}</div>
              <Input v-model="processContent" type="textarea" :rows="3" :placeholder="$t('permission_configuration_management.common.pleaseInput')" />
              <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-top: 12px;">
                <Button :loading="aiLoading" type="primary" @click="aiIdentification">{{ $t('configuration_management.customized_alarm_config.identification') }}</Button>
                <div v-if="aiTips" style="margin-left: 16px; flex: 1;">
                  <span style="font-weight: 700; color: #ed4014;">*{{ $t('Bill.ResourceOptimization.prompt') }}：</span>
                  <span style="color: #ed4014;">{{ aiTips }}</span>
                </div>
              </div>
              <div v-if="sopSteps.length > 0" class="sop-timeline-wrap" style="margin-top: 16px;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                  <span style="font-weight: 600;">{{ $t('configuration_management.customized_alarm_config.processStepList') }}</span>
                  <span style="color: #808695; font-size: 12px;">{{ $t('configuration_management.customized_alarm_config.maxSteps') }}</span>
                </div>
                <draggable v-model="sopSteps" handle=".sop-step-handle" class="sop-step-list">
                  <div v-for="(val, index) in sopSteps" :key="val.stepId || ('step-' + index)" class="sop-step-row">
                    <span class="sop-step-handle">≡</span>
                    <div class="sop-step-dot">{{ index + 1 }}</div>
                    <Input
                      v-model="sopSteps[index].stepInfo"
                      type="textarea"
                      :autosize="{ minRows: 1, maxRows: 3 }"
                      style="flex: 1;"
                      :placeholder="$t('configuration_management.customized_alarm_config.pleaseEnterStepContent')"
                    />
                    <Button size="small" type="text" style="color: #ed4014;" @click="deleteStep(index)">
                      <Icon type="md-trash" />
                    </Button>
                  </div>
                </draggable>
                <Button v-if="sopSteps.length < 15" type="dashed" long style="margin-top: 8px;" @click="addStep">
                  <Icon type="md-add" /> {{ $t('configuration_management.customized_alarm_config.addStep') }}
                </Button>
              </div>
            </div>
          </Card>
          <Card style="margin-top: 10px">
            <div>{{ $t('configuration_management.customized_alarm_config.pleaseConfigureTheNotificationTemplate') }}</div>
            <div style="margin-top: 10px">
              <Table border :columns="tableColumns" :data="aiItemData.sopEmailTemplates">
                <template slot-scope="{ row, index }" slot="action">
                  <div style="display: flex;">
                    <Button
                      type="text"
                      size="small"
                      style="color: #2d8cf0"
                      @click="submitItem(row)"
                    >
                      {{ $t("common.ok") }}</Button
                    >
<!--                    <Button-->
<!--                      v-if="index > 1"-->
<!--                      type="text"-->
<!--                      size="small"-->
<!--                      style="color: #ed4014;"-->
<!--                      @click="deleteItem(index)"-->
<!--                    >-->
<!--                      {{ $t("common.del") }}</Button-->
<!--                    >-->
                  </div>
                </template>
              </Table>
<!--              <Button type="primary" shape="circle" icon="md-add" style="margin-top: 10px" @click="addTableItem"></Button>-->
            </div>
          </Card>
          <div style="text-align: right; margin-top: 16px;">
            <Button @click="showEditAI = false">{{ $t('BillingServices.cancel') }}</Button>
            <Button type="primary" style="margin-left: 8px;" :loading="submitSopLoading" @click="submitSopItem">{{ $t('common.ok') }}</Button>
          </div>
        </div>
      </Modal>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import {filterOutDeprecatedMetrics} from '../../../../utils/deprecatedMetrics.js'
    import draggable from 'vuedraggable'
    import TableCustomerDefinedAlarmConfiguration from '../customer_defined_alarm_configuration/TableCustomerDefinedAlarmConfiguration'
    var tableCustomerDefinedAlarmConfiguration = TableCustomerDefinedAlarmConfiguration;
    export default {
        name: 'CustomerDefinedAlarmConfigurationSearch',
        components: {
            draggable
        },
        data () {
            return {
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                accountTypeSearchKey:'-1',
                accountTypeList:[],
                accountTypeNames:'',
                // 新增筛选条件
                monitorModuleSearchKey: ' ',
                monitorModuleList: [],
                monitorIndexSearchKey: ' ',
                monitorIndexList: [],
                prioritySearchKey: ' ',
                priorityOptions: [
                  { value: 0, label: 'P1' },
                  { value: 1, label: 'P2' },
                  { value: 2, label: 'P3' },
                  { value: 3, label: 'P4' }
                ],
                stateSearchKey: ' ',
                aiMonitorAlertStatusSearchKey: ' ',
              openAIDialog: false,
              selectedSopItem: null,
              aiList: [],
              showEditAI: false,
              processContent: '',
              // 编辑状态记录，格式为 { rowIndex_field: boolean }
              editingState: {},
              // 当前编辑的值，用于临时存储
              editingValue: '',
              tableColumns: [
                {
                  title: this.$t('message.templateName'),
                  key: 'templateName',
                  width: 100,
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_templateName`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'text',
                          value: params.row.templateName
                        },
                        on: {
                          input: (event) => {
                            params.row.templateName = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'templateName');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        // on: {
                        //   dblclick: () => {
                        //     this.startEdit(params.index, 'templateName');
                        //   }
                        // },
                        // style: {
                        //   cursor: 'pointer',
                        //   minHeight: '30px',
                        //   lineHeight: '30px'
                        // }
                      }, params.row.templateName);
                    }
                  }
                },
                {
                  title: this.$t('configuration_management.customized_alarm_config.recipient'),
                  slot: 'recipient',
                  width: 150,
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_recipient`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'text',
                          value: params.row.recipient
                        },
                        on: {
                          input: (event) => {
                            params.row.recipient = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'recipient');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        on: {
                          dblclick: () => {
                            this.startEdit(params.index, 'recipient');
                          }
                        },
                        style: {
                          cursor: 'pointer',
                          minHeight: '30px',
                          lineHeight: '30px'
                        }
                      }, params.row.recipient);
                    }
                  }
                },
                {
                  title: this.$t('alarms.common.emailTemplate'),
                  slot: 'templateContent',
                  render: (h, params) => {
                    // 获取当前单元格的编辑状态
                    const editingKey = `${params.index}_templateContent`;
                    const isEditing = this.editingState[editingKey];
                    if (isEditing) {
                      return h('Input', {
                        props:{
                          type:'textarea',
                          rows: 3,
                          value: params.row.templateContent
                        },
                        on: {
                          input: (event) => {
                            params.row.templateContent = event;
                          },
                          'on-blur': () => {
                            this.saveEdit(params.index, 'templateContent');
                          }
                        }
                      });
                    } else {
                      return h('div', {
                        on: {
                          dblclick: () => {
                            this.startEdit(params.index, 'templateContent');
                          }
                        },
                        style: {
                          cursor: 'pointer',
                          minHeight: '30px',
                          lineHeight: '30px'
                        }
                      }, params.row.templateContent);
                    }
                  }
                },
                {
                  title: this.$t("common.operation"),
                  slot: "action",
                  width: 120
                }
              ],
              aiItemData: {},
              aiTips: '',
              sopSteps: [],
              aiLoading: false,
              editingStepIndex: -1,
              submitSopLoading: false
            }
        },
        computed: {
            monitorIndexEnabled: function() {
                var hasCloudPlatform = this.accountTypeSearchKey !== ' ' && this.accountTypeSearchKey !== '' && this.accountTypeSearchKey !== '-1' && this.accountTypeSearchKey !== null && this.accountTypeSearchKey !== undefined;
                var hasMonitorModule = this.monitorModuleSearchKey !== ' ' && this.monitorModuleSearchKey !== '' && this.monitorModuleSearchKey !== null && this.monitorModuleSearchKey !== undefined;
                return hasCloudPlatform && hasMonitorModule;
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
            this.getAccountType();
            this.getMonitorModuleList();
        },
        methods: {
            // 跳转
            to: function() {
               this.$router.push({
                  path: '/configurationManagement/alertRuleLists',
                  query: { companyId: this.companyId }
               });
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
            },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableCustomerDefinedAlarmConfiguration.methods.showAll();
            },
            //查询账户类型
            getAccountType: function(){
                this.$api.account.queryCloudPlatforms("userName",getCookie(global.cookieName))
                .then(res => {
                    this.accountTypeList = res.data;
                })
            },
            // 查询监控模块下拉
            getMonitorModuleList: function() {
                this.$api.alertRule.searchMonitorModule("userName", getCookie(global.cookieName))
                  .then(res => {
                      this.monitorModuleList = res.data || [];
                  })
                  .catch(() => {
                      this.monitorModuleList = [];
                  });
            },
            // 查询监控指标下拉
            getMonitorIndexList: function() {
                if (!this.monitorIndexEnabled) {
                    this.monitorIndexList = [];
                    return;
                }
                var params = {
                    monitorModule: this.monitorModuleSearchKey,
                    cloudPlatform: this.accountTypeSearchKey
                };
                this.$api.alertRule.searchDefaultMonitorIndexByCloudPlatform(params)
                  .then(res => {
                      this.monitorIndexList = filterOutDeprecatedMetrics(res.data || []);
                  })
                  .catch(() => {
                      this.monitorIndexList = [];
                  });
            },
            // 账户类型（云平台）联动：切换时重新加载监控指标列表
            onAccountTypeChange: function() {
                this.monitorIndexSearchKey = ' ';
                this.getMonitorIndexList();
            },
            // 监控模块联动：切换时重新加载监控指标列表
            onMonitorModuleChange: function() {
                this.monitorIndexSearchKey = ' ';
                this.getMonitorIndexList();
            },
            // 统一查询
            doSearch: function() {
                eventBus.$emit('companyId', this.companyId);
                eventBus.$emit('accountTypeNames', this.accountTypeSearchKey);
                eventBus.$emit('monitorModule', this.monitorModuleSearchKey);
                eventBus.$emit('monitorIndex', this.monitorIndexSearchKey);
                eventBus.$emit('priority', this.prioritySearchKey);
                // state 和 aiMonitorAlertStatus 从字符串转回 Boolean
                var stateVal = this.stateSearchKey;
                if (stateVal === 'true') stateVal = true;
                else if (stateVal === 'false') stateVal = false;
                eventBus.$emit('state', stateVal);
                var aiStatusVal = this.aiMonitorAlertStatusSearchKey;
                if (aiStatusVal === 'true') aiStatusVal = true;
                else if (aiStatusVal === 'false') aiStatusVal = false;
                eventBus.$emit('aiMonitorAlertStatus', aiStatusVal);
                tableCustomerDefinedAlarmConfiguration.methods.showAll();
            },
          // 打开通用AI SOP
          showAIDialog() {
            this.openAIDialog = true
            this.selectedSopItem = null
            this.$api.customerDefinedAlarmConfiguration.defaultSopList().then(res => {
                this.aiList = res.data.data
                // 默认选中第一个
                if (this.aiList && this.aiList.length > 0) {
                    this.selectedSopItem = this.aiList[0]
                }
            })
          },
          // 选择优先级
          selectSopItem(item) {
            this.selectedSopItem = item
          },
          // 打开编辑SOP弹框
          showSopItem(e) {
            this.showEditAI = true
            this.aiItemData = e
            this.processContent = ''
            this.aiTips = ''
            // 回显已有的 SOP 步骤
            this.sopSteps = (e.sopSteps && e.sopSteps.length > 0) ? JSON.parse(JSON.stringify(e.sopSteps)) : []
            this.editingStepIndex = -1
          },
          changeStatus(e) {
            this.$api.customerDefinedAlarmConfiguration.updateEmailStatus(e.sopId, e.enableEmail).then(res => {
              if (res.data.code === 200) {
                this.$Message.success(this.$t('configuration_management.customized_alarm_config.modifySuccess'))
              } else {
                this.$Message.error(res.data.message)
              }
            })
          },
          // ai识别
          aiIdentification() {
            if (!this.processContent) return
            this.aiLoading = true
            const data = {
              userInput: this.processContent,
              emailTemplateList: this.aiItemData.sopEmailTemplates.map(item => item.templateName)
            }
            this.$api.customerDefinedAlarmConfiguration.sopIdentify(data).then(res => {
              if (res.data.code !== 200) {
                this.aiTips = res.data.message
                this.sopSteps = []
              } else {
                this.aiTips = ''
                this.sopSteps = res.data.data
              }
            }).finally(() => {
              this.aiLoading = false
            })
          },
          // 新增列表项
          addTableItem() {
              this.aiItemData.sopEmailTemplates.push({
                templateName: '',
                recipient: '',
                templateContent: ''
              })
          },
          deleteItem(i) {
            this.aiItemData.sopEmailTemplates.splice(i, 1)
          },
          addStep() {
            if (this.sopSteps.length >= 15) return
            this.sopSteps.push({ stepId: 'new_' + Date.now(), stepInfo: '' })
            this.editingStepIndex = this.sopSteps.length - 1
          },
          deleteStep(index) {
            if (this.sopSteps.length <= 1) {
              this.$Message.warning(this.$t('configuration_management.customized_alarm_config.atLeastOneStep'))
              return
            }
            this.sopSteps.splice(index, 1)
            if (this.editingStepIndex === index) this.editingStepIndex = -1
            else if (this.editingStepIndex > index) this.editingStepIndex--
          },
          moveStep(index, direction) {
            const target = index + direction
            if (target < 0 || target >= this.sopSteps.length) return
            const temp = this.sopSteps[index]
            this.$set(this.sopSteps, index, this.sopSteps[target])
            this.$set(this.sopSteps, target, temp)
            if (this.editingStepIndex === index) this.editingStepIndex = target
            else if (this.editingStepIndex === target) this.editingStepIndex = index
          },
          // 开始编辑
          startEdit(index, field) {
            const editingKey = `${index}_${field}`;
            this.$set(this.editingState, editingKey, true);
          },
          // 保存编辑
          saveEdit(index, field) {
            const editingKey = `${index}_${field}`;
            // 退出编辑状态
            this.$set(this.editingState, editingKey, false);
          },
          submitItem(e) {
              const data = {
                id: e.id,
                templateName: e.templateName,
                recipient: e.recipient,
                templateContent: e.templateContent
              }
            this.$api.customerDefinedAlarmConfiguration.sopConfirm(data).then(res => {
              this.$Message.success(this.$t('configuration_management.customized_alarm_config.confirmSuccess'))
            })
          },
          submitSopItem() {
              if (this.sopSteps.length <= 0) {
                this.$Message.error(this.$t('configuration_management.customized_alarm_config.stepsCannotBeEmpty'))
                return
              }
              const hasEmpty = this.sopSteps.some(s => !s.stepInfo || !s.stepInfo.trim())
              if (hasEmpty) {
                this.$Message.error(this.$t('configuration_management.customized_alarm_config.pleaseFillAllSteps'))
                return
              }
            const data = {
              defaultSopPriority: this.aiItemData.priority,
              enableEmail: this.aiItemData.enableEmail,
              sopSteps: this.sopSteps
            }
            this.submitSopLoading = true
            this.$api.customerDefinedAlarmConfiguration.defaultSop(data).then(res => {
              if (res.data.code === 200) {
                this.$Message.success(this.$t('configuration_management.customized_alarm_config.submitSuccess'))
                this.showEditAI = false
                this.$api.customerDefinedAlarmConfiguration.defaultSopList().then(res => {
                  this.aiList = res.data.data
                  // 刷新选中项
                  if (this.selectedSopItem) {
                    var found = this.aiList.find(item => item.priority === this.selectedSopItem.priority)
                    if (found) this.selectedSopItem = found
                  }
                })
              } else {
                this.$Message.error(res.data.message)
              }
            }).finally(() => {
              this.submitSopLoading = false
            })
          }
        }
    }
</script>
<style>
    .customerDefinedAlarmConfigurationSearch
    {
        padding: 4px 0px 15px 0px;
    }
    .sop-split-layout {
      display: flex;
      gap: 16px;
      min-height: 400px;
    }
    .sop-priority-list {
      width: 180px;
      flex-shrink: 0;
      border-right: 1px solid #e8eaec;
      padding-right: 16px;
    }
    .sop-priority-item {
      padding: 12px;
      border: 1px solid #e8eaec;
      border-radius: 4px;
      margin-bottom: 8px;
      cursor: pointer;
      transition: all 0.2s;
    }
    .sop-priority-item:hover {
      border-color: #2d8cf0;
    }
    .sop-priority-item.active {
      border-color: #2d8cf0;
      background: #f0f7ff;
    }
    .sop-detail-panel {
      flex: 1;
      min-width: 0;
    }
    .sop-timeline-wrap {
      border: 1px solid #e8eaec;
      border-radius: 6px;
      padding: 12px 16px;
      background: #fafafa;
    }
    .sop-step-list {
      max-height: 400px;
      overflow-y: auto;
    }
    .sop-step-row {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 8px 0;
      border-bottom: 1px solid #f0f0f0;
    }
    .sop-step-row:last-child {
      border-bottom: none;
    }
    .sop-step-handle {
      color: #c5c8ce;
      font-size: 16px;
      cursor: grab;
      flex-shrink: 0;
    }
    .sop-step-dot {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: #2d8cf0;
      color: #fff;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      flex-shrink: 0;
    }
    .sop-step-actions {
      display: flex;
      align-items: center;
      gap: 4px;
      flex-shrink: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/CustomerDefinedAlarmConfigurationSearch.vue